import { styled } from '@linaria/react';

import VennDiagram from './VennDiagram';

const VennDiagramInPost = (delegated) => {
  return (
    <Wrapper>
      <VennDiagram {...delegated} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 75%;
  margin-inline: auto;
  margin-bottom: 48px;
  margin-top: 16px;
  font-size: 1.375rem;

  @media (max-width: 700px) {
    font-size: 1.25rem;
    width: 100%;
  }
  @media (max-width: 500px) {
    width: calc(100% + var(--viewport-padding) * 2);
    margin-inline: calc(var(--viewport-padding) * -1);
    font-size: 1.175rem;
    overflow-x: clip;
  }
`;

export default VennDiagramInPost;
